import swal from 'sweetalert';

const SweetAlert = {
    DEFAULT_ERROR_MESSAGE: 'Server error occurred. Try again later',
    defaultError: () => {
        return SweetAlert.error(SweetAlert.DEFAULT_ERROR_MESSAGE);
    },
    close: () => {
        swal.close();
    },
    error: (message: string): Promise<any> => {
        return swal({
            title: 'Error',
            text: message,
            icon: 'error',
        });
    },
    processing: (message: string = 'Processing...'): Promise<any> => {
        return swal({
            text: message,
            icon: '/images/loader.gif',
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: [false],
        });
    },
    loader: <T>(promise: Promise<T>, message?: string): Promise<T> => {
        SweetAlert.processing(message);

        return promise.finally(SweetAlert.close);
    },
    success: (message: string): Promise<any> => {
        return swal({
            title: 'Success',
            text: message,
            icon: 'success',
        });
    },
    warning: (message: string, button: string): Promise<any> => {
        return swal({
            title: 'Warning',
            text: message,
            icon: 'warning',
            buttons: ['Cancel', button],
        });
    },
};

export default SweetAlert;
